import { render } from "./TgSelect.vue?vue&type=template&id=6f01c0b5"
import script from "./TgSelect.vue?vue&type=script&lang=js"
export * from "./TgSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__